import "./polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import "./assets/moonlabs-icons/css/style.css";
import { Toaster } from "react-hot-toast";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "@rainbow-me/rainbowkit/styles.css";
import {
  RainbowKitProvider,
  getDefaultWallets,
  connectorsForWallets,
  lightTheme,
} from "@rainbow-me/rainbowkit";
import { trustWallet, ledgerWallet } from "@rainbow-me/rainbowkit/wallets";
import { configureChains, createClient, WagmiConfig } from "wagmi";
import { mainnet, goerli } from "wagmi/chains";
import { alchemyProvider } from "wagmi/providers/alchemy";
import { publicProvider } from "wagmi/providers/public";
import ErrorPage from "./error-page";
import { AuthProvider } from "./modules/auth/AuthContext";
import TwitterError from "./routes/error/twitter";
import Sale from "./routes/Sale";
import Referrals from "./routes/Referrals";
import FreeClaim from "./routes/FreeClaim";

const { chains, provider, webSocketProvider } = configureChains(
  [
    ...(process.env.REACT_APP_ENABLE_TESTNETS === "true"
      ? [goerli]
      : [mainnet]),
  ],
  [
    alchemyProvider({
      apiKey: process.env.REACT_APP_ALCHEMY_API_KEY as string,
    }),
    publicProvider(),
  ],
);

const { wallets } = getDefaultWallets({
  appName: "Chaos Symphony",
  chains,
});

const connectors = connectorsForWallets([
  ...wallets,
  {
    groupName: "Other",
    wallets: [trustWallet({ chains }), ledgerWallet({ chains })],
  },
]);
const wagmiClient = createClient({
  autoConnect: true,
  connectors,
  provider,
  webSocketProvider,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Sale />,
  },
  {
    path: "/mint",
    element: <Sale />,
  },
  {
    path: "/mint/:referralAddress",
    element: <Sale />,
  },
  {
    path: "/referrals",
    element: <Referrals />,
  },
  {
    path: "/claim",
    element: <FreeClaim />,
  },
  {
    path: "/error/twitter",
    element: <TwitterError />,
  },
  {
    path: "*",
    element: <ErrorPage />,
  },
]);

root.render(
  <React.StrictMode>
    <WagmiConfig client={wagmiClient}>
      <RainbowKitProvider
        modalSize="compact"
        chains={chains}
        theme={lightTheme({
          accentColor: "#000",
          borderRadius: "none",
        })}
      >
        <AuthProvider>
          <RouterProvider router={router} />
          <Toaster />
        </AuthProvider>
      </RainbowKitProvider>
    </WagmiConfig>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
